import _ from "lodash";
import { ModalType } from "./types/modalType";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../redux/hooks";
import { IRootState } from "../../../types/redux/IRootStore";
import AplSettingsSelector from "../../../redux/helpers/AplSettingsSelector";
import { DtGrid2 } from "../DtGrid2";
import { translateColumns, translateString } from "../../../translations/gridTranslationHelper";
import { getPrintHistoryColumns } from "./printHistoryGridColumns";
import { DtGridPropsOptions2 } from "../../../types/dtGridPropsOptions2";
import { onClearPrintHistoryFooters, printHistoryFootersApi } from "../../../redux/slices/printHistoryFooters.feature";
import React from "react";
import BsModal2DefaultButtons from "./BsModal2DefaultButtons";
import { closeModalRedux as closeModal } from "../../../redux/slices/modalPallets2.feature";
import { UserPermission } from "../../../types/userPermission";

export default function ModalPrintHistory2() {
    const modalPalletsRedux = useSelector((state: IRootState) => state.modalPallets2);
    const printHistoryFootersRedux = useSelector((state: IRootState) => state.printHistoryFooters);
    const aplSettings = AplSettingsSelector();
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        if (modalPalletsRedux.modalShown === ModalType.PrintHistory) dispatch(printHistoryFootersApi(aplSettings.siteId) as any);
        return () => {
            dispatch(onClearPrintHistoryFooters());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalPalletsRedux.modalShown]);

    const [page, setPage] = React.useState<number>(1);
    
    const dtGridPropsLabl: DtGridPropsOptions2 = {
        data: printHistoryFootersRedux.printHistoryFooters,
        columnData: translateColumns(getPrintHistoryColumns(aplSettings.siteId, aplSettings.culture, dispatch, aplSettings.hasPermAnyLine(UserPermission.PalReprint)), aplSettings.culture),
        loading: printHistoryFootersRedux.printHistoryFootersLoading,
        tableName: "tblPrintHistoryFooters",
        paging: true,
        showSpinner: printHistoryFootersRedux.printHistoryFootersLoading,
        spinnerMarginClass: "mt-1",
        defaultSort: {
            field: ["rowCreatedTimeStamp"],
            direction: ["desc"]
        },
        selectType: "none",
        colouring: false,
        headerFilters: false,
        setSelectedItems: _.noop,
        selectedItems: [],
        tableClass: "table-print-history-footers",
        rowId: "printId",
        pageLength: 20,
        filters: {},
        setFilters: _.noop,
        page: page,
        setPage: setPage
    };

    return (
        <React.Fragment>
            <div className="modal-header">
                <h5>{translateString("litPrintHistory", aplSettings.culture)}</h5>
                <button
                    type="button"
                    className="close"
                    onClick={() => {
                        dispatch(closeModal());
                    }}
                >
                    <span aria-hidden="true" className="text-danger">
                        ×
                    </span>
                    <span className="sr-only">Close</span>
                </button>
            </div>
            <div className="modal-body">
                <DtGrid2 options={dtGridPropsLabl} />
                <BsModal2DefaultButtons
                    closeFunction={() => {
                        dispatch(closeModal());
                    }}
                    culture={aplSettings.culture}
                />
            </div>
        </React.Fragment>
    );
}
